import { TileSize } from "game-common/models"

// Walls sort at their base row + TileSize/3, with a small layer offset.
// Roofs belong just above that band, not at the bottom of the whole cell:
// several trees in the next row have trunks extending north of their parent.
export const roofGroundDepth = (southRow: number): number =>
    100 + southRow * TileSize + TileSize / 3 + 3

// Keep higher storeys above the ceiling without moving the building's depth
// into the next row. Elevation already determines their screen position.
export const sceneFloorGroundDepth = (southRow: number, floor: number): number =>
    roofGroundDepth(southRow) + 1 + floor / (floor + 1)
